import { BKJCenteredDialog } from 'components/BKJCenteredDialog';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DeleteOpenShiftDialogProps } from 'pages/LocationSettingsPage/PositionsAllocation/DeleteOpenShiftDialog/DeleteOpenShiftDialog.types';
import {
  DeleteOpenShiftDialogFormProvider,
  useDeleteOpenShiftDialogFormProviderFormContext,
} from 'pages/LocationSettingsPage/PositionsAllocation/DeleteOpenShiftDialog/DeleteOpenShiftDialog.form.context';

const DeleteOpenShiftDialogView: FC<DeleteOpenShiftDialogProps> = ({
  isDeleteOpenShiftConfirmationOpen,
  setIsDeleteOpenShiftConfirmationOpen,
}) => {
  const { t } = useTranslation();
  const { handleOpenShift } = useDeleteOpenShiftDialogFormProviderFormContext();
  return (
    <BKJCenteredDialog
      isOpen={isDeleteOpenShiftConfirmationOpen}
      variant="Danger"
      title={t('dialog:DELETE_SHIFT')}
      text={t('dialog:DELETE_SHIFT_WARNING')}
      cancelLabel={t('auth:BACK')}
      actionLabel={t('auth:CONFIRM')}
      onAction={() => {
        setIsDeleteOpenShiftConfirmationOpen(false);
        return handleOpenShift();
      }}
      onCancel={() => setIsDeleteOpenShiftConfirmationOpen(false)}
      onClose={() => setIsDeleteOpenShiftConfirmationOpen(false)}
    />
  );
};

export const DeleteOpenShiftDialog: FC<DeleteOpenShiftDialogProps> = (props) => {
  return (
    <DeleteOpenShiftDialogFormProvider {...props}>
      <DeleteOpenShiftDialogView {...props} />
    </DeleteOpenShiftDialogFormProvider>
  );
};
